import { Container, Grid2 } from "@mui/material";
import React from "react";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import whySustain from "../assets/images/banner-left-image.png";
import swiggyPackaging from "../assets/images/swiggy-packaging.png";
import whySustainIcon1 from "../assets/images/eco-friendly-packaging.png";
import whySustainIcon2 from "../assets/images/recyclable-materials.png";
import whySustainIcon3 from "../assets/images/brand-and-budget.png";
import whySustainIcon4 from "../assets/images/exclusive-deals.png";

const Sustainability = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/#explore-vendors"); // Redirect with hash
  };
  return (
    <>
      <section className="dish-banner inner-baner common-banner">
        <Container>
          <div className="breadcrumb">
            <Breadcrumbs />
          </div>

          <div className="banner-content">
            <h1 className="text-white-highest-emphasis">
              Rethink Packaging.
              <br /> Redefine Impact.
            </h1>
            <p className="text-dark-high-emphasis">
              Food delivery is booming - and so is the packaging waste that
              comes with it. That’s why we’re making it easier for restaurant
              partners to switch to sustainable packaging solutions that leave
              behind happy customers, not plastic waste.
            </p>
          </div>
        </Container>
      </section>
      <section className="section-padding">
        <Container>
          <Grid2
            container
            alignItems="center"
            spacing={{ xs: 1, md: "20px" }}
            className="items-center"
          >
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <div class="section-title whymatter-sustain">
                <h2>Why It Matters</h2>
                <p>
                  Each order delivered is a chance to do better - for the planet
                  and for your brand. Sustainable packaging isn’t just about
                  going green - it’s about showing your customers that you care
                  about what happens beyond the plate.
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="why-sustain-image">
                <img src={whySustain} alt="" />
              </div>
            </Grid2>
          </Grid2>
        </Container>
      </section>
      <section className="section-padding">
        <Container>
          <div className="section-title text-center support-heading">
            <h2>How Swiggy Supports You</h2>
            <p>Through our platform, you can now</p>
          </div>
          <Grid2 container spacing={{ xs: 2, md: 3 }} className="items-center">
            <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
              <div className="swiggy-support-card">
                <img src={whySustainIcon1} alt="" />
                <p className="text-sub-heading">
                  Discover eco-friendly packaging vendors
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
              <div className="swiggy-support-card">
                <img src={whySustainIcon2} alt="" />
                <p className="text-sub-heading">
                  Choose from biodegradable, compostable, and recyclable
                  materials
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
              <div className="swiggy-support-card">
                <img src={whySustainIcon3} alt="" />
                <p className="text-sub-heading">
                  Compare options that suit your brand and budget
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 6, md: 4, lg: 3 }}>
              <div className="swiggy-support-card">
                <img src={whySustainIcon4} alt="" />
                <p className="text-sub-heading">
                  Get access to exclusive deals curated for Swiggy partners
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
              <p className="text-center body-text">
                Everything you need to make the switch is available on our site.
              </p>
            </Grid2>
          </Grid2>
        </Container>
      </section>
      <section className="section-padding measurable-impact">
        <Container>
          <Grid2
            container
            alignItems="center"
            spacing={{ xs: 1, md: "20px" }}
            className="items-center"
          >
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="section-title whymatter-sustain">
                <h2 className="whymatter-sustain">Make a Measurable Impact</h2>
                <p>
                  By choosing sustainable packaging through Swiggy’s platform,
                  you’re not just ticking a box - you’re contributing to a
                  larger movement towards responsible business. Whether you're
                  looking to meet internal sustainability goals or align with
                  customer expectations, our vendor ecosystem is designed to
                  help you act with impact.
                </p>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="why-sustain-image">
                <img src={swiggyPackaging} alt="" />
              </div>
            </Grid2>
          </Grid2>
        </Container>
      </section>
      <section className="section-padding cta-sustain bg-dark">
        <Container>
          <Grid2
            container
            justifyContent={"center"}
            spacing={{ xs: 1, md: "20px" }}
            className="items-center"
          >
            <Grid2 size={{ xs: 12, md: 10, lg: 8 }}>
              <div className="cta-content">
                <div className="section-title">
                  <h2 className="text-white">Ready to go green?</h2>
                  <p className="text-white">
                    Start browsing sustainable packaging options
                  </p>
                </div>
                <div className="cta-link">
                  <button onClick={handleClick} className="btn btn-orange">
                    Explore Solutions
                  </button>
                </div>
              </div>
            </Grid2>
          </Grid2>
        </Container>
      </section>
    </>
  );
};

export default Sustainability;
